
export class ResetPassword {
    username :string;
    password :string;
    }